<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" size="small" @click="add"
          >新建教育金</el-button
        >
      </div>
      <div>
        <el-input
          clearable
          v-model.trim="searchCondition.keyWords"
          placeholder="请输入姓名/电话"
          size="small"
          style="width:300px"
          class="ipt mr10"
        >
          <el-select
            slot="prepend"
            style="width:100px"
            v-model="searchCondition.agentType"
            size="small"
          >
            <el-option label="支付代理" value="pay"></el-option>
            <el-option label="接收代理" value="obtain"></el-option>
          </el-select>
        </el-input>

        <el-select
          clearable
          v-model="searchCondition.fundCalcMode"
          placeholder="请选择教育金计算方式"
          filterable
          style="width:200px"
          size="small"
          class="mr10"
        >
          <el-option label="全代理链路计算" value="full"></el-option>
          <el-option label="当前代理人分销计算" value="now"></el-option>
        </el-select>
        <el-date-picker
          :default-time="['00:00:00', '23:59:59']"
          class="mr10"
          size="small"
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="searchCondition.date"
          type="datetimerange"
          range-separator="至"
          start-placeholder="选择申请起始日期"
          end-placeholder="选择申请起始日期"
        ></el-date-picker>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="flex flex-start mb10">
      <el-radio-group
        v-model="searchCondition.timeStatus"
        size="small"
        @change="switchTab"
      >
        <el-radio-button label="going">进行中</el-radio-button>
        <el-radio-button label="notStart">待开始</el-radio-button>
        <el-radio-button label="end">已结束</el-radio-button>
      </el-radio-group>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="enabledState"
          label="教育金状态"
        >
          <template slot-scope="scope">
            <span class="success" v-if="scope.row.enabledState === 'yes'">
              上线
            </span>
            <span class="danger" v-if="scope.row.enabledState === 'no'">
              下线
            </span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="payAgentName"
          label="支付代理"
        >
          <template slot-scope="scope">
            {{ scope.row.payAgentName }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="receiptAgentName"
          label="收取代理"
        >
          <template slot-scope="scope">
            {{ scope.row.receiptAgentName }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="fundRatio"
          label="教育金比例"
        >
          <template slot-scope="scope">
            {{ scope.row.fundRatio }}%
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="fundCalcMode"
          label="教育金计算方式"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.fundCalcMode === 'full'">
              全代理链路计算
            </div>
            <div v-else>
              当前代理人分销计算
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="shareOrderNum"
          header-align="center"
          align="center"
          label="教育金时段"
        >
          <template slot-scope="scope">
            {{ scope.row.fundStartDate }}至{{ scope.row.fundEndDate }}
          </template>
        </el-table-column>

        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="remark"
          label="备注"
        >
          <template slot-scope="scope">
            <span class="primary">{{ scope.row.remark }}</span>
          </template>
        </el-table-column> -->

        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                size="small"
                v-if="searchCondition.timeStatus !== 'end'"
                @click="edit(scope.row)"
                :class="[scope.row.enabledState === 'yes' ? 'danger' : 'blue']"
                type="text"
                >{{
                  scope.row.enabledState === "yes" ? "下线" : "上线"
                }}</el-button
              >
              <el-button
                size="small"
                v-if="searchCondition.timeStatus !== 'end'"
                @click="end(scope.row)"
                class="danger"
                type="text"
                >结束</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="新建教育金"
      width="800px"
      :visible.sync="dialogVisible"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
      >
        <div class="p10" style="fontWeight: 700">
          教育金主要用于XXXXXXXXXXXXXXXXX
        </div>
        <el-form-item label="教育金时段" prop="educationDate">
          <el-date-picker
            :default-time="['00:00:00', '23:59:59']"
            class="mr10"
            size="small"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="ruleForm.educationDate"
            type="datetimerange"
            range-separator="至"
            start-placeholder="选择开始日期"
            end-placeholder="选择结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="计算方式" prop="fundCalcMode">
          <el-select
            clearable
            v-model="ruleForm.fundCalcMode"
            placeholder="计算方式"
            filterable
            size="small"
            class="mr10"
          >
            <el-option label="全代理链路计算" value="full"></el-option>
            <el-option label="当前代理人分销计算" value="now"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付主体" prop="zfMember">
          <div>
            <el-input
              clearable
              style="width:220px"
              v-model.trim="zfKeyWords"
              placeholder="请输入电话号码"
              size="small"
              @input="filterGt0OrFixedMobile('zfKeyWords')"
              class="ipt mr10"
            ></el-input>

            <el-button
              :disabled="zfKeyWords === '' || zfShow"
              type="primary"
              size="small"
              @click="searchZf"
              >查询</el-button
            >
          </div>
          <div
            class="table-body flex flex-between"
            v-for="(v, i) in zfMember"
            :key="i"
          >
            <div class="agent">{{ v.agentName }}</div>
            <div class="agent">{{ v.titleName }}</div>
            <div class="agent">代理奖励：{{ v.actualRewardRatio }}%</div>
          </div>
        </el-form-item>
        <el-form-item label="接收主体" prop="jsMember">
          <div>
            <el-input
              clearable
              style="width:220px"
              v-model.trim="jsKeyWords"
              placeholder="请输入电话号码"
              size="small"
              @input="filterGt0OrFixedMobile('jsKeyWords')"
              class="ipt mr10"
            ></el-input>

            <el-button
              :disabled="jsKeyWords === '' || jsShow"
              type="primary"
              size="small"
              @click="searchJs"
              >查询</el-button
            >
          </div>
          <div
            class="table-body flex flex-between"
            v-for="(v, i) in jsMember"
            :key="i"
          >
            <div class="agent">{{ v.agentName }}</div>
            <div class="agent">{{ v.titleName }}</div>
            <div class="agent">代理奖励：{{ v.actualRewardRatio }}%</div>
          </div>
        </el-form-item>
        <!-- <el-form-item label="发生主体" prop="mainBody">
          <div>
            <el-input
              clearable
              style="width:220px"
              v-model.trim="keyWords"
              placeholder="请输入电话号码"
              size="small"
              class="ipt mr10"
            ></el-input>

            <el-button
              :disabled="keyWords === ''"
              type="primary"
              size="small"
              @click="searchAgent"
              >查询</el-button
            >
          </div>
          <div
            class="table-body flex flex-wrap"
            v-for="(v, i) in ruleForm.memberInfo"
            :key="i"
          >
            <div class="agent">{{ v.agentName }}</div>
            <div class="agent">{{ v.titleName }}</div>
            <div class="agent">代理奖励：{{ v.actualRewardRatio }}%</div>
            <el-button
              type="text"
              size="small"
              class="blue ml10"
              v-if="v.is === 'zhiFu' || !v.flag"
              :disabled="v.flag"
              @click="ok(v, 'zhiFu')"
              >支付代理</el-button
            >
            <el-button
              type="text"
              size="small"
              class="blue ml10"
              v-if="v.is === 'jieShou' || !v.flag"
              :disabled="v.flag"
              @click="ok(v, 'jieShou')"
              >接收代理</el-button
            >
          </div>
        </el-form-item> -->
        <el-form-item label="奖励金" prop="fundRatio">
          <el-input
            clearable
            style="width:220px"
            @mousewheel.prevent.native
            v-model.trim="ruleForm.fundRatio"
            @input="filterGt0OrFixed2('fundRatio')"
            placeholder="奖励金"
            size="small"
            class="ipt mr10"
          ></el-input
          >%
          <div class="form-item-tip mt10">
            奖励金由支付代理的代理奖励中直接扣除，不按照百分比计算。
          </div>
          <div class="form-item-tip mt10">
            例如A代理支付给B代理5%的奖励金，且A代理的奖励金绝对比例为58%，则实际A拿到的代理奖励只有53%，5%需要支付给B。
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center mt20">
        <el-button @click="submitForm('ruleForm')" size="small" type="primary">
          确 认</el-button
        >
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    const conditFunc = function(rule, val, callback) {
      if (this.ruleForm.memberInfo.length < 2) {
        return callback(new Error("请选择发生主体"));
      } else {
        this.ruleForm.memberInfo.map(v => {
          if (v.is !== "zhiFu" && v.is !== "jieShou") {
            return callback(new Error("请选择发生主体代理类型"));
          }
        });
      }
      callback();
    }.bind(this);
    const zfMemberFunc = function(rule, val, callback) {
      if (!this.zfMember.length) {
        return callback(new Error("请选择支付主体"));
      } else {
        if (this.jsMember.length) {
          if (this.jsMember[0].centerId === this.zfMember[0].centerId) {
            return callback(new Error("接收主体与支付主体不能为同一人"));
          }
        }
      }
      callback();
    }.bind(this);
    const jsMemberFunc = function(rule, val, callback) {
      if (!this.jsMember.length) {
        return callback(new Error("请选择接收主体"));
      } else {
        if (this.zfMember.length) {
          if (this.jsMember[0].centerId === this.zfMember[0].centerId) {
            return callback(new Error("接收主体与支付主体不能为同一人"));
          }
        }
      }
      callback();
    }.bind(this);
    const bonusFunc = function(rule, val, callback) {
      this.ruleForm.memberInfo.map(v => {
        if (v.is === "zhiFu") {
          if (val > v.actualRewardRatio) {
            return callback(new Error(`奖励金不能超过${v.actualRewardRatio}`));
          }
        }
      });
      //   if (
      //     val === "conditionCommission" &&
      //     this.ruleForm.conditionCommission.length < 1
      //   ) {
      //     return callback(new Error("请选择条件"));
      //   }
      callback();
    }.bind(this);
    return {
      jsShow: true,
      zfShow: true,
      jsMember: [],
      jsKeyWords: "",
      zfMember: [],
      zfKeyWords: "",
      keyWords: "",
      ruleForm: {
        educationDate: [],
        fundCalcMode: "",
        memberInfo: [],
        fundRatio: ""
      },
      rules: {
        educationDate: {
          required: true,
          message: "请选择教育金时段",
          trigger: "blur"
        },
        fundCalcMode: {
          required: true,
          message: "请选择计算方式",
          trigger: "blur"
        },
        zfMember: {
          required: true,
          validator: zfMemberFunc,
          trigger: "blur"
        },
        jsMember: {
          required: true,
          validator: jsMemberFunc,
          trigger: "blur"
        },
        mainBody: {
          required: true,
          validator: conditFunc,
          trigger: "blur"
        },
        fundRatio: [
          {
            required: true,
            message: "请填写奖励金",
            trigger: "blur"
          },
          {
            required: true,
            validator: bonusFunc,
            trigger: "blur"
          }
        ]
      },
      dialogVisible: false,
      list: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      searchCondition: {
        agentType: "pay",
        timeStatus: "going"
      }
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.startGetcashTime = this.isArray(searchCondition.date)
        ? searchCondition.date[0]
        : "";

      searchCondition.endGetcashTime = this.isArray(searchCondition.date)
        ? searchCondition.date[1]
        : "";

      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryShareAgentEducList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    myDate() {
      let date = new Date();
      return `${date.getFullYear()}-${date.getMonth() +
        1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
    },
    end(row) {
      this.$confirm("是否确认结束？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const newRow = JSON.parse(JSON.stringify(row));
          // newRow.fundEndDate = this.myDate();
          newRow.progressState = "no";
          this.updateEduc(newRow);
        })
        .catch(() => {});
    },
    edit(row) {
      const newRow = JSON.parse(JSON.stringify(row));
      newRow.enabledState = newRow.enabledState === "no" ? "yes" : "no";

      this.updateEduc(newRow);
    },
    async updateEduc(row) {
      const { code } = await this.$store.dispatch("editShareAgentEduc", row);
      if (code === "0") {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.queryList();
      }
    },
    add() {
      this.dialogVisible = true;
    },
    ok(v, val) {
      this.ruleForm.memberInfo.map((item, i) => {
        if (item.is === val) {
          this.ruleForm.memberInfo.splice(i, 1);
        }
      });

      v.flag = true;
      v.is = val;
    },
    filterGt0OrFixed2(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    filterGt0OrFixedMobile(prop) {
      if (/^1[0-9]{10}$/.test(this[prop])) {
        if (prop === "zfKeyWords") {
          this.zfShow = false;
        } else {
          this.jsShow = false;
        }
      } else {
        if (prop === "zfKeyWords") {
          this.zfShow = true;
        } else {
          this.jsShow = true;
        }
      }
    },
    errMsg() {
      this.$message({
        type: "warning",
        message: "该手机号"
      });
    },
    async searchZf() {
      let params = {
        pageSize: 100,
        pageNo: 1,
        keyWords: this.zfKeyWords
      };
      const { result } = await this.$store.dispatch("queryAgentList", params);
      if (result.records.length > 0) {
        this.zfMember = [result.records[0]];
      }
    },
    async searchJs() {
      let params = {
        pageSize: 100,
        pageNo: 1,
        keyWords: this.jsKeyWords
      };
      const { result } = await this.$store.dispatch("queryAgentList", params);
      if (result.records.length > 0) {
        this.jsMember = [result.records[0]];
      }
    },
    async searchAgent() {
      let params = {
        pageSize: 100,
        pageNo: 1,
        keyWords: this.keyWords
      };
      const { result } = await this.$store.dispatch("queryAgentList", params);
      if (result.records.length > 0) {
        result.records.forEach(v => {
          v.flag = false;
          v.is = "";
        });
        let show = true;
        this.ruleForm.memberInfo.forEach(v => {
          if (v.shareAgentId === result.records[0].shareAgentId) {
            show = false;
          }
        });
        if (show) {
          this.ruleForm.memberInfo.push(...result.records);
        }
      }
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    switchTab() {
      this.currentPage = 1;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    resetRuleForm(formName) {
      this.$refs[formName].resetFields();
      this.keyWords = "";
      this.jsMember = [];
      this.jsKeyWords = "";
      this.zfMember = [];
      this.zfKeyWords = "";
    },
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        let params = this.ruleForm;
        params.fundStartDate = params.educationDate[0];
        params.fundEndDate = params.educationDate[1];
        // params.memberInfo.forEach(v => {
        //   if (v.is === "zhiFu") {
        //     params.payAgentId = v.shareAgentId;
        //   } else if (v.is === "jieShou") {
        //     params.obtainAgentId = v.shareAgentId;
        //   }
        // });
        params.payAgentId = this.zfMember[0].shareAgentId;
        params.obtainAgentId = this.jsMember[0].shareAgentId;
        const { code } = await this.$store.dispatch(
          "addShareAgentEduc",
          params
        );
        if (code === "0") {
          this.$message({
            type: "success",
            message: "操作成功"
          });
          setTimeout(() => {
            this.resetRuleForm(formName);
          }, 0);
          this.dialogVisible = false;
          this.queryList();
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.table-body {
  width: 400px;
  padding: 5px 0;
  .agent {
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 14px;
    // width: 73px;
    // margin-right: 20px;
    color: #222;
  }
}
</style>
